<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="btn btn-primary"
          to="/ajouter-emploi"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter un emploi du temps
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form
          class="search-box position-relative me-15"
          @submit.prevent="rechercher"
        >
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un emploi du temps"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Type</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Date Début</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Date Fin</th>
              <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Filière</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Niveau</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Matière</th> -->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(emploi, index) in emploisDuTemps" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ emploi.typeEmploi?.libelle }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ new Date(emploi.dateDebut).toLocaleDateString() }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ new Date(emploi.dateFin).toLocaleDateString() }}</td>
              <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ emploi.cours && emploi.cours.length > 0 ? emploi.cours[0].filiereNiveauMatiere?.filiere?.libelle : '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ emploi.cours && emploi.cours.length > 0 ? emploi.cours[0].filiereNiveauMatiere?.niveau?.libelle : '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ emploi.cours && emploi.cours.length > 0 ? emploi.cours[0].filiereNiveauMatiere?.matiere?.libelle : '-' }}
              </td> -->
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <span
                    class="badge text-white bg-primary fs-15 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        :to="{ name: 'EditEmploiPage', params: { id: emploi.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'ViewEmploiPage', params: { id: emploi.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="suppression(emploi.id, emploisDuTemps, 'emplois-du-temps', `l'emploi du temps ${emploi.typeEmploi?.libelle}`)"
                      >
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import ApiService from "../../services/ApiService";
import {
  suppression,
  error,
  success,
} from "../../utils/utils";
import PaginationComponent from "../../components/Utilities/Pagination.vue";
import JwtService from "../../services/JwtService";

export default defineComponent({
  name: "ListeEmploiDuTemps",
  components: {
    PaginationComponent,
  },
  setup() {
    onMounted(() => {
      getAllEmploisDuTemps();
    });

    const emploisDuTemps = ref<Array<any>>([]);
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        getAllEmploisDuTemps(page_, limit_);
      } catch (err) {
        error("Erreur lors de la pagination");
      }
    };

     function getAllEmploisDuTemps(page = 1, limi = 10, searchTerm = "") {
      const query = searchTerm.trim() ? `&mot=${encodeURIComponent(searchTerm.trim())}` : "";
      return ApiService.get(`/emplois-du-temps?page=${page}&limit=${limi}${query}&`)
        .then(({ data }) => {
          emploisDuTemps.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response?.data?.message || "Erreur lors du chargement des compositions");
          emploisDuTemps.value = [];
        });
    }

    function rechercher() {
      page.value = 1; // Toujours repartir à la page 1
      getAllEmploisDuTemps(page.value, limit.value, searchTerm.value);
    }

   /* function rechercher() {
      getAllEmploisDuTemps(page.value, limit.value, searchTerm.value);
    }

    function getAllEmploisDuTemps(page = 1, limi = 10, search = "") {
      // Supprime les caractères qui ne servent pas pour la recherche
      const cleanedSearch = search.trim();

      return ApiService.get(
        `/emplois-du-temps?page=${page}&limit=${limi}&searchTerm=${encodeURIComponent(cleanedSearch)}`
      )
        .then(({ data }) => {
          emploisDuTemps.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response?.data?.message || "Erreur lors du chargement des emplois du temps");
        });
    }*/

    const deleteEmploiDuTemps = async (id: number) => {
      try {
        const { data } = await ApiService.delete(`/emplois-du-temps/${id}`);

        Swal.fire({
          text: data.message,
          toast: true,
          icon: "success",
          title: "Suppression réussie",
          animation: false,
          position: "top-right",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          heightAuto: false,
        });

        await getAllEmploisDuTemps(page.value, limit.value, searchTerm.value);

        if (emploisDuTemps.value.length === 0 && page.value > 1) {
          page.value -= 1;
          await getAllEmploisDuTemps(page.value, limit.value, searchTerm.value);
        }
      } catch (err: any) {
        Swal.fire({
          text: err.response?.data?.message || "Impossible de supprimer l'emploi du temps",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réessayer à nouveau !",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semibold btn-light-danger",
          },
        });
      }
    };

    const confirmDelete = (id: number, titre: string) => {
      Swal.fire({
        title: "Êtes-vous sûr ?",
        text: `Vous êtes sur le point de supprimer l'emploi du temps : ${titre}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
        customClass: {
          confirmButton: "btn fw-semibold btn-danger me-2",
          cancelButton: "btn fw-semibold btn-light",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          deleteEmploiDuTemps(id);
        }
      });
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      emploisDuTemps,
      checkPermission,
      getAllEmploisDuTemps,
      deleteEmploiDuTemps,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
    };
  },
});
</script>

<style>
.truncate {
  width: 250px;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
